import { FC, PropsWithChildren } from "react";
import {
  ChatMessageBubbleContext,
  ChatMessageBubbleContextValue,
} from "./ChatMessageBubbleContext";

export const ChatMessageBubbleProvider: FC<
  PropsWithChildren<ChatMessageBubbleContextValue>
> = ({ children, ...props }) => (
  <ChatMessageBubbleContext.Provider value={props}>
    {children}
  </ChatMessageBubbleContext.Provider>
);
